// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n@keyframes animatePopoverIn{\n0%{\n    opacity:0;\n    transform:perspective(500px) rotateX(-15deg)\n}\nto{\n    opacity:1;\n    transform:perspective(0) rotateX(0deg)\n}\n}\n@keyframes animatePopoverOut{\n0%{\n    opacity:1;\n    transform:perspective(0) rotateX(0deg)\n}\nto{\n    opacity:0;\n    transform:perspective(500px) rotateX(-15deg)\n}\n}\n.trustpilot-widget{\n  width:100%\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
